import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { Icon, Item, SubTitle, Title } from './styles';

type PropTypes = {
  titleKey: string;
  imgSrc: string;
  subtitleKey: string;
};

const NumberShowcaseItem: FC<PropTypes> = ({ titleKey, imgSrc, subtitleKey }) => (
  <Item>
    <Icon src={imgSrc} alt="" />
    <Title>
      <FormattedMessage id={titleKey} />
    </Title>
    <SubTitle>
      <FormattedMessage id={subtitleKey} />
    </SubTitle>
  </Item>
);

export default NumberShowcaseItem;
